/**
 * The Merge Lord crest as a standalone `data:` URI, used to replace the
 * signed-in Merge Lord's sidebar avatar.
 *
 * This renders inside an `<img src>` (the sidebar avatar), where the design
 * system's token `currentColor` cannot inherit — so the crest carries fixed,
 * legible colors. This is the single permitted inline color in the feature,
 * justified by the `<img>` boundary. Kept deliberately simple (crown + face)
 * so it reads at ~32px.
 */
const SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
<rect width="96" height="96" rx="22" fill="#1f2937"/>
<path d="M30 40 L34 28 L42 36 L48 23 L54 36 L62 28 L66 40 Z" fill="#e5e7eb"/>
<circle cx="48" cy="58" r="17" fill="none" stroke="#e5e7eb" stroke-width="4"/>
<circle cx="42" cy="55" r="2.6" fill="#e5e7eb"/>
<circle cx="54" cy="55" r="2.6" fill="#e5e7eb"/>
<path d="M41 63 q7 7 14 0" stroke="#e5e7eb" stroke-width="3.5" fill="none" stroke-linecap="round"/>
</svg>`;

export const MERGE_LORD_AVATAR_DATA_URI = `data:image/svg+xml;utf8,${encodeURIComponent(
  SVG,
)}`;
